import { Vector2, Vector3 } from 'three'

class InteractiveTileConfig {
  // 3d position from imported scene
  position: Vector3
  // 2d coords for game grid
  coords: Vector2
  // flag to avoid rendering in scene
  isValid: boolean
  // flag to allow/deny user to interact with this position
  isAvailable: boolean

  constructor(x: number, y: number, valid: boolean = false) {
    this.coords = new Vector2(x, y)
    this.position = new Vector3(0, 0, 0)
    this.isValid = valid
    this.isAvailable = false
  }
}

export default InteractiveTileConfig
